module.exports = __webpack_public_path__ + "static/spread-2f9d83e0a1704b3ae7762dfaa8dba987.jpg";